/**
 * @generated SignedSource<<dcb257e1cc9333db271a6c7ab209c1a3>>
 * @relayHash 7b417b148a22cb5f455f01e8c88fdf27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2358cc71b341e57461e0da2ffe1740e7c5582aae7edf9810cb457628285df47e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type InsightsRecommendationVisibility = "HIDDEN" | "REMOVED" | "SNOOZED" | "VISIBLE" | "%future added value";
export type footer_NBTPanelGithubOnboardingDetails_Query$variables = {
  cloudId: string;
  projectAri?: string | null | undefined;
};
export type footer_NBTPanelGithubOnboardingDetails_Query$data = {
  readonly insights: {
    readonly githubOnboardingDetails: {
      readonly outboundAuthUrl: string;
      readonly recommendationVisibility: InsightsRecommendationVisibility;
    };
  } | null | undefined;
};
export type footer_NBTPanelGithubOnboardingDetails_Query = {
  response: footer_NBTPanelGithubOnboardingDetails_Query$data;
  variables: footer_NBTPanelGithubOnboardingDetails_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "concreteType": "Insights",
    "kind": "LinkedField",
    "name": "insights",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "projectAri"
          }
        ],
        "concreteType": "InsightsGithubOnboardingDetails",
        "kind": "LinkedField",
        "name": "githubOnboardingDetails",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "recommendationVisibility"
          },
          {
            "kind": "ScalarField",
            "name": "outboundAuthUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "footer_NBTPanelGithubOnboardingDetails_Query",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "footer_NBTPanelGithubOnboardingDetails_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "2358cc71b341e57461e0da2ffe1740e7c5582aae7edf9810cb457628285df47e",
    "metadata": {},
    "name": "footer_NBTPanelGithubOnboardingDetails_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f769c58fa1d409f05a59bfa11acc5e27";

export default node;
